import React from 'react';

const ReserveForm = ({ handleAddCss, isAdd }) => {

    return (
        <div className={isAdd ? null : "active"} id="reserve_table_popup">
            <span onClick={handleAddCss} className="popup_close"><i className="ion-ios-close-empty"></i></span>
            <div className="table_reserve_form">
                <div className="section_header">
                    <img src="images/title_border.png" alt="" />
                    <h2 className="section_title">Reserve Table</h2>
                </div>
                <form className="reserve_form" action="contact.php" method="post">
                    <div className="form-container">
                        <div className="form-group">
                            <label for="name">Your Name</label>
                            <input type="text" id="name" name="name" className="form-control" placeholder="Ex: John Doe" required="" />
                        </div>
                        <div className="form-group">
                            <label for="number">No. of Person</label>
                            <input type="number" id="number" name="number" className="form-control" placeholder="No. of Person" value="" min="1" required="" />
                        </div>
                        <div className="form-group">
                            <label for="date">Date</label>
                            <input type="date" id="date" name="date" className="form-control" required="" />
                        </div>
                        <div className="form-group">
                            <label for="time">Time</label>
                            <input type="time" id="time" name="time" className="form-control" required="" />
                        </div>
                        <div className="button_group">
                            <input className="button" type="submit" value="Reserve A Table" name="submit" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReserveForm;